import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineOptions } from "vue";

export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'InputSelect',
  props: { no_data_text: { required: false, type: String } },
  setup(__props) {

const props = __props;


return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, _mergeProps(_ctx.$attrs, {
    class: "custom-select",
    density: "compact",
    variant: "outlined",
    "no-data-text": props.no_data_text || 'No data available',
    "menu-props": { contentClass: 'custom__text__selector' }
  }), null, 16, ["no-data-text"]))
}
}

})